import { render, staticRenderFns } from "./PapeletaDescanso.vue?vue&type=template&id=1b5554b8&scoped=true"
import script from "./PapeletaDescanso.vue?vue&type=script&lang=js"
export * from "./PapeletaDescanso.vue?vue&type=script&lang=js"
import style0 from "./PapeletaDescanso.vue?vue&type=style&index=0&id=1b5554b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5554b8",
  null
  
)

export default component.exports